<template>
  <div>
    <Head :title="__(title)" />
    <div class="mb-6 flex justify-between items-center">
      <search-input v-model="form.search" class="w-full max-w-md mr-auto" @reset="reset" />
      <Link
        class="btn-indigo mr-1" :href="route('faqs.cancel')" method="post" as="button" type="button"
        preserve-scroll
      >
        {{ __('Back to FAQs') }}
      </Link>
      <Link v-if="user_access.category.create" class="btn-indigo" :href="route('faq-categories.create')">
        <span>{{ __('Create New') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="px-6 pt-6 pb-4">{{ __('Name') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('FAQs Count') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Status') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="category in categories.data" :key="category.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center focus:text-indigo-500"
                :href="route('faq-categories.edit', category.id)"
              >
                {{ category.name }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center" :href="route('faq-categories.edit', category.id)"
                tabindex="-1"
              >
                {{ category.faqs_count }}
              </Link>
            </td>
            <td class="border-t">
              <Link
                class="px-6 py-4 flex items-center" :href="route('faq-categories.edit', category.id)"
                tabindex="-1"
              >
                {{ category.status ? 'Active' : 'Inactive' }}
              </Link>
            </td>
            <td class="border-t w-px">
              <Link
                class="px-4 flex items-center" :href="route('faq-categories.edit', category.id)"
                tabindex="-1"
              >
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="categories.data.length === 0">
            <td class="border-t px-6 py-4" colspan="4">{{ __('No categories found.') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="categories.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchInput from '@/Shared/SearchInput'
import { Link, Head } from '@inertiajs/vue3'

export default {
    metaInfo: { title: 'FAQ Categories' },
    components: {
        Icon,
        Pagination,
        SearchInput,
        Link,
        Head,
    },
    layout: Layout,
    props: {
        filters: Object,
        categories: Object,
        title: String,
        auth: Object,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
            },
            user_access: this.$page.props.auth.user.access || {},
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(route('faq-categories.index'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
